(function(){
    var NotifyModal = function($el) {
        this.$el = $el
        this.$body = this.$el.find('.modal-body')
        this.$question = this.$el.find('.modal-question')
        this.$methodSelect = this.$el.find('select[name=method]')
        this.$loader = this.$el.find('.loading')
        this.$submitButton = this.$el.find('.confirm-notify-button')
        this.$eventButton = null
        this.$methodOptions = null
        this.$showInvoicePreviewButton = false
        this.$invoiceId = null

        this.$el.on('show.bs.modal', this.show.bind(this))
        this.$el.on('hide.bs.modal', this.hide.bind(this))
        this.$submitButton.on('click', this.submit.bind(this))

        return this
    }

    NotifyModal.prototype.showLoader = function () {
        this.$submitButton.prop('disabled', true)
        this.$body.hide()
        this.$loader.fadeIn()
    }

    NotifyModal.prototype.showBody = function () {
        this.$submitButton.prop('disabled', false)
        this.$loader.hide()
        this.$body.fadeIn()
    }

    NotifyModal.prototype.show = function (event) {
        this.$eventButton = $(event.relatedTarget)
        this.$methodOptions = this.$eventButton.data('options')
        this.$showInvoicePreviewButton = this.$eventButton.data('has-invoice-button')
        this.$invoiceId = this.$eventButton.data('invoice-id')
        $('#invoice-preview').attr('data-invoice-id', this.$invoiceId);
        this.render()
        this.showBody()
    }

    NotifyModal.prototype.render = function () {
        var options = this.$methodOptions.split(',')
        this.$methodSelect.html('')

        for (var i = 0; i < options.length; i++) {
            var option = options[i].split(':')

            this.$methodSelect.append($('<option/>', { 
                 value: option[0],
                 text: option[1],
            }));
        }

        this.$question.html(this.$eventButton.data('notify-message'))

        if(this.$showInvoicePreviewButton){
            this.$el.find('.show-invoice-preview-modal').show();
            // this.$el.find('.show-invoice-preview-modal').attr('data-invoice-id') = this.$invoiceId;
        }
    }

    NotifyModal.prototype.hide = function (event) {
        //for some reason this.$el does not have access to the modal function
        // $('.notify-modal').modal('hide')
        this.$el.find('.show-invoice-preview-modal').hide();
        $('#invoice-preview').html('');
        $('#invoice-preview').hide();
        $('#invoice-preview').attr('data-invoice-id', '');
    }

    NotifyModal.prototype.error = function (data) {
        this.hide()

	    $.each(data.responseJSON, function(key, value) {
		    $.each(value, function(key, value) {
                alert(value)
        	});
        });
    }

    NotifyModal.prototype.submit = function () {
        this.showLoader()

        var request = {
            method: 'post',
            url: this.$eventButton.data('notify-url'),
            data: {
                method: this.$methodSelect.val()
            }
        }

        $.ajax(request)
		    .done($('.notify-modal').modal('hide'))
		    .fail(this.error.bind(this))
    }

	$('.notify-modal').each(function () {
		new NotifyModal($(this))
	})
})()

